import * as React from "react";

/**
 * Skeleton — shaped placeholder for content that's fetching.
 *
 * Usage:
 *   <Skeleton className="h-4 w-24" />
 *   <SkeletonText lines={3} />
 *   <SkeletonRow /> (dense-table row-shaped)
 *   <SkeletonCard /> (card-shaped)
 *
 * Honours prefers-reduced-motion via a static rendering (no shimmer).
 */

const BASE = "bg-brand-rule/60 rounded";

export function Skeleton({ className = "", testid }) {
  return (
    <div
      className={`${BASE} animate-pulse ${className} motion-reduce:animate-none`}
      aria-hidden="true"
      data-testid={testid || "skeleton"}
    />
  );
}

export function SkeletonText({ lines = 1, className = "" }) {
  const widths = ["w-11/12", "w-9/12", "w-10/12", "w-8/12"];
  return (
    <div className={`space-y-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className={`${BASE} h-3 ${widths[i % widths.length]} animate-pulse motion-reduce:animate-none`} />
      ))}
    </div>
  );
}

export function SkeletonRow({ cells = 4 }) {
  return (
    <tr aria-hidden="true">
      {Array.from({ length: cells }).map((_, i) => (
        <td key={i}><Skeleton className="h-3 w-full" /></td>
      ))}
    </tr>
  );
}

export function SkeletonCard({ className = "" }) {
  return (
    <div className={`card-panel ${className}`} aria-hidden="true">
      <div className="card-panel-head">
        <div className="min-w-0 flex-1">
          <Skeleton className="h-2.5 w-14" />
          <Skeleton className="h-4 w-40 mt-2" />
        </div>
        <Skeleton className="h-6 w-16" />
      </div>
      <div className="card-panel-body space-y-2">
        <SkeletonText lines={3} />
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 6, cols = 5 }) {
  return (
    <div className="fable-table" aria-hidden="true">
      <table>
        <thead>
          <tr>{Array.from({ length: cols }).map((_, i) => <th key={i}><Skeleton className="h-2.5 w-16" /></th>)}</tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => <SkeletonRow key={r} cells={cols} />)}
        </tbody>
      </table>
    </div>
  );
}
